import React, { useContext } from 'react';
import { Col, Progress, Row } from 'reactstrap';
import { H6, LI, P, UL, Image } from '../../../AbstractElements';
import { Comment, Issues, Resolved } from '../../../Constant';
import ProjectContext from '../../../Context/ProjectContext';
const AllProjectData = ({ filterProject }) => {
  const { allProject } = useContext(ProjectContext);
  var images = require.context('../../../assets/images', true);
  const dynamicImage = (image) => {
    return images(`./${image}`);
  };
  let project;
  if (filterProject === 'Doing') {
    project = allProject.filter((item) => item.progress < 100);
  } else if (filterProject === 'Done') {
    project = allProject.filter((item) => item.progress === 100);
  } else {
    project = allProject;
  }

  return (
    <>
      <Row>
        {project.map((item) => (
          <Col xl='4 col-lg-6 box-col-33' key={item.id}>
            <div className='project-box'>
              <span className={`badge ${item.progress < 100 ? 'badge-primary' : 'badge-secondary'}`}>{item.progress < 100 ? 'Doing' : 'Done'}</span>
              <H6>{item.title}</H6>
              <div className='d-flex'>
                <Image className='img-20 me-2 rounded-circle' src={`${dynamicImage(item.img)}`} alt='' />
                <div className='flex-grow-1'>
                  <P>{item.sites}</P>
                </div>
              </div>
              <P>{item.desc}</P>
              <Row className='details'>
                <Col xs='6'>
                  <span>{Issues} </span>
                </Col>
                <Col xs='6' className={item.progress < 100 ? 'font-primary' : 'font-secondary'}>
                  {item.issue}
                </Col>
                <Col xs='6'>
                  <span>{Resolved}</span>
                </Col>
                <Col xs='6' className={item.progress < 100 ? 'font-primary' : 'font-secondary'}>
                  {item.resolved}
                </Col>
                <Col xs='6'>
                  <span>{Comment}</span>
                </Col>
                <Col xs='6' className={item.progress < 100 ? 'font-primary' : 'font-secondary'}>
                  {item.comment}
                </Col>
              </Row>
              <div className='customers'>
                <UL className='simple-list flex-row'>
                  <LI className='d-inline-block'>
                    <Image className='img-30 rounded-circle' style={{ height: 'auto' }} src={`${dynamicImage(item.customers_img1)}`} alt='' />
                  </LI>
                  <LI className='d-inline-block'>
                    <Image className='img-30 rounded-circle' style={{ height: 'auto' }} src={`${dynamicImage(item.customers_img2)}`} alt='' />
                  </LI>
                  <LI className='d-inline-block'>
                    <Image className='img-30 rounded-circle' style={{ height: 'auto' }} src={`${dynamicImage(item.customers_img3)}`} alt='' />
                  </LI>
                  <LI className='d-inline-block ms-2'>
                    <P className='f-12'>{`${item.like} More`}</P>
                  </LI>
                </UL>
              </div>
              <div className='project-status mt-4'>
                <div className='d-flex mb-0'>
                  <P>{item.progress}% </P>
                  <div className='flex-grow-1 text-end'>
                    <span>{item.progress < 100 ? 'Doing' : 'Done'}</span>
                  </div>
                </div>
                {item.progress < 100 ? <Progress className='sm-progress-bar' striped color='primary' value={item.progress} style={{ height: '5px' }} /> : <Progress className='sm-progress-bar' color='secondary' value={item.progress} style={{ height: '5px' }} />}
              </div>
            </div>
          </Col>
        ))}
      </Row>
    </>
  );
};
export default AllProjectData;
